import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  const handleCTAClick = () => {
    const pricingSection = document.getElementById('pricing');
    pricingSection?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="w-full bg-gradient-to-b from-[#C7E0E7] to-[#A8C7D1] py-16 md:py-24 px-4" data-id="element-17">
      <div className="max-w-4xl mx-auto text-center" data-id="element-18">
        <motion.h2 className="text-3xl md:text-5xl font-bold text-[#2C2C2C] mb-6 leading-tight" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-19">
          Si hoy estás viviendo
          <br data-id="element-20" />
          <span className="text-white" data-id="element-21">"no puedo ni ir al baño"…</span>
        </motion.h2>

        <motion.div className="text-lg md:text-xl text-[#2C2C2C]/90 mb-8 leading-relaxed" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-22">
          <p className="mb-4" data-id="element-23">No necesitas más consejos sueltos.</p>
          <p className="font-semibold text-[#2C2C2C]" data-id="element-24">
            Necesitas un plan que puedas repetir sin pensar.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-25">
          <CTAButton onClick={handleCTAClick} variant="secondary" className="shadow-2xl" ariaLabel="Descargar Plan" data-id="element-26">
            Descargar Plan
          </CTAButton>
        </motion.div>
      </div>
    </section>;
}